export default defineNuxtRouteMiddleware(async () => {
  if (localStorage.getItem("dataPegawai")) {
    useUserDataStore().$patch((state) => {
      state.dataPegawai = JSON.parse(localStorage.getItem("dataPegawai")) || {};
    });
  }
  if (localStorage.getItem("dataPegawai")) {
    useUserDataStore().$patch((state) => {
      state.isRoleAsn =
        ["PNS", "CPNS", "PPPK", "ASN", "NON-ASN"].includes(
          JSON.parse(localStorage.getItem("dataPegawai")).statusPegawai,
        ) || false;
    });
  }
  if (localStorage.getItem("profile")) {
    useUserDataStore().$patch((state) => {
      state.profile = JSON.parse(localStorage.getItem("profile")) || {};
    });
  }
});
